// extracted by mini-css-extract-plugin
export default {"table-cell":"TableSkeleton_table-cell__aP-Xa","tr":"TableSkeleton_tr__aSlWz","table-row":"TableSkeleton_table-row__erp2l"};